var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 15.5395V6.71319C3.33337 4.33484 3.33337 3.14568 4.06561 2.40683C4.79784 1.66797 5.97635 1.66797 8.33337 1.66797H11.6667C14.0237 1.66797 15.2022 1.66797 15.9345 2.40683C16.6667 3.14568 16.6667 4.33484 16.6667 6.71319V15.5395C16.6667 16.7992 16.6667 17.4291 16.2817 17.677C15.6526 18.0822 14.6801 17.2325 14.191 16.9241C13.7868 16.6691 13.5848 16.5417 13.3605 16.5344C13.1181 16.5264 12.9125 16.6486 12.4758 16.9241L10.8834 17.9283C10.4538 18.1991 10.239 18.3346 10 18.3346C9.76104 18.3346 9.54629 18.1991 9.11671 17.9283L7.52432 16.9241C7.12017 16.6691 6.91809 16.5417 6.69382 16.5344C6.45147 16.5264 6.24582 16.6486 5.8091 16.9241C5.32 17.2325 4.34743 18.0822 3.71833 17.677C3.33337 17.4291 3.33337 16.7992 3.33337 15.5395Z",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 9.16797H6.66663",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 5.83203H6.66663",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlack);
export default __webpack_public_path__ + "static/media/payment-black.37626535adc08c381b19231d719bd460.svg";
export { ForwardRef as ReactComponent };